import RequireData from "hooks/RequireData";
import React from "react";
import { ListGroup } from "react-bootstrap";
import { useDispatch } from "react-redux";
import teamInvitees from "selectors/teamInvitees";
import teamInviteesStatus from "selectors/teamInviteesStatus";
import TeamDetailInviteesRow from "./TeamDetailInviteesRow";

interface Props {
    teamId: string | null;
}

const TeamDetailInvitees: React.FC<Props> = ({ teamId }) => {
    const [invitees, status] = RequireData(
        teamInvitees(teamId || ""),
        teamInviteesStatus(teamId || ""),
        {
            type: "com.sage.actions.team.IFetchTeamInivitees",
            teamId: teamId,
        } as sage.actions.team.IFetchTeamInivitees
    );

    const dispatch = useDispatch();

    React.useEffect(() => {
        if (!teamId) {
            return;
        }
        dispatch({
            type: "com.sage.actions.team.IFetchTeamInivitees",
            teamId: teamId,
        } as sage.actions.team.IFetchTeamInivitees);
    }, [teamId, dispatch]);

    if (status !== "none") {
        return null;
    }

    if (!invitees || invitees.length === 0) {
        return null;
    }

    return (
        <>
            <div className="row align-items-center">
                <div className="col">
                    <h5>Pending Invites</h5>
                </div>
            </div>
            <ListGroup>
                {invitees.map((i) => (
                    <TeamDetailInviteesRow
                        teamId={teamId || ""}
                        key={i}
                        email={i}
                    />
                ))}
            </ListGroup>
        </>
    );
};

export default TeamDetailInvitees;
